import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// API Base URL
const API_BASE_URL = 'https://api.aml-pep-data.com/api/v1';

// Async actions for CRUD operations
export const fetchDataCounts = createAsyncThunk('dataCount/fetchDataCounts', async () => {
  const response = await axios.get(`${API_BASE_URL}/get-data-count`);
  return response.data.data; // Ensure only the 'data' array is returned
});

export const createDataCount = createAsyncThunk('dataCount/createDataCount', async (newData) => {
  const response = await axios.post(`${API_BASE_URL}/create-data-count`, newData);
  return response.data; // Assuming the response contains the created data
});

export const updateDataCount = createAsyncThunk('dataCount/updateDataCount', async ({ id, updatedData }) => {
  const response = await axios.put(`${API_BASE_URL}/update-data-count/${id}`, updatedData);
  return response.data; // Assuming the response contains the updated data
});

export const deleteDataCount = createAsyncThunk('dataCount/deleteDataCount', async (id) => {
  await axios.delete(`${API_BASE_URL}/delete-data-count/${id}`);
  return id; // Returning the id to remove from the state
});

const dataCountSlice = createSlice({
  name: 'dataCount',
  initialState: {
    dataCounts: [], // Should be an array of data counts
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Data
      .addCase(fetchDataCounts.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchDataCounts.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.dataCounts = action.payload; // Now this is an array
      })
      .addCase(fetchDataCounts.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      // Create Data
      .addCase(createDataCount.fulfilled, (state, action) => {
        // Assuming the response contains the created data
        state.dataCounts.push(action.payload); // Add the newly created data to the list
      })
      // Update Data
      .addCase(updateDataCount.fulfilled, (state, action) => {
        // Replace the updated data in the state
        const index = state.dataCounts.findIndex((item) => item.id === action.payload.id);
        if (index !== -1) {
          state.dataCounts[index] = action.payload; // Update the data item in the array
        }
      })
      // Delete Data
      .addCase(deleteDataCount.fulfilled, (state, action) => {
        // Filter out the deleted item
        state.dataCounts = state.dataCounts.filter((item) => item.id !== action.payload);
      });
  },
});

export default dataCountSlice.reducer;
